import { createI18n } from 'vue-i18n'
import { utils } from 'frontendcommon-3'

const DEFAULT_LOCALE = process.env.VUE_APP_I18N_LOCALE || 'es'
const FALLBACK_LOCALE = process.env.VUE_APP_I18N_LOCALE || 'es'
const { messageCompiler } = utils.i18nUtils

function setupI18n (options) {
  const i18n = createI18n({
    locale: DEFAULT_LOCALE,
    globalInjection: true,
    fallbackLocale: FALLBACK_LOCALE,
    messages: {},
    warnHtmlMessage: false,
    legacy: false,
    csp: true, // Enable CSP-safe mode
    messageCompiler, // Use CSP-safe compiler instead of JIT
    ...options
  })

  return i18n
}

export const i18n = setupI18n()
